import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";

const json = {
  1: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P17-E1",
    audio: "img/FriendsPlus/Page17/Audio/audio-e1-p17.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page17/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tieude-e1-p17.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/3.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page17/E1/4.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/5.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/6.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/7.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/8.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/9.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/10.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page17/E1/11.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/12.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/13.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/14.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/15.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/16.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/17.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page17/E1/18.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/19.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/drum.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/20.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/21.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/dress.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/22.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/23.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/truck.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/24.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/25.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tree.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/26.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/27.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/crayon.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/28.jpg" },
        {
          url: "img/FriendsPlus/Page17/E1/29.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/crab.mp3",
        },
        { url: "img/FriendsPlus/Page17/E1/30.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page17/E1/31.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P17-E2",
    audio: "img/FriendsPlus/Page17/Audio/audio-e2-p17.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page17/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page17/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tieude-e2-p17.mp3",
        },
        { url: "img/FriendsPlus/Page17/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page17/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P17-E3",
    audio: "",
    video: "",
    component: DesignUnderLine,
    totalInput: 9,
    exerciseKey: "img/FriendsPlus/Page17/E3/Key/answerKey.png",
    question: [],
    questionImage: [
      [
        // Column18
        { url: 'img/FriendsPlus/Page17/E3/77.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page17/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page17/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page17/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/5.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page17/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/7.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page17/E3/8.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/9.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page17/E3/10.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page17/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/12.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page17/E3/13.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/15.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page17/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/17.jpg', input: 8 },
        { url: 'img/FriendsPlus/Page17/E3/18.jpg', input: 9, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/19.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page17/E3/20.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page17/E3/21.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/22.jpg', input: 10 },
        { url: 'img/FriendsPlus/Page17/E3/23.jpg', input: 11, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/24.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/25.jpg', input: 12 },
        { url: 'img/FriendsPlus/Page17/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/27.jpg', input: 13 },
        { url: 'img/FriendsPlus/Page17/E3/28.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/29.jpg', input: 14, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/30.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page17/E3/31.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page17/E3/32.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/33.jpg', input: 15 },
        { url: 'img/FriendsPlus/Page17/E3/34.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/35.jpg', input: 16 },
        { url: 'img/FriendsPlus/Page17/E3/36.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page17/E3/37.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/38.jpg', input: 18 },
        { url: 'img/FriendsPlus/Page17/E3/39.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page17/E3/40.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page17/E3/41.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/42.jpg', input: 19 },
        { url: 'img/FriendsPlus/Page17/E3/43.jpg', input: 20 },
        { url: 'img/FriendsPlus/Page17/E3/44.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/45.jpg', input: 21 },
        { url: 'img/FriendsPlus/Page17/E3/46.jpg', input: 22 },
        { url: 'img/FriendsPlus/Page17/E3/47.jpg', input: 23, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/48.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page17/E3/49.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page17/E3/50.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/51.jpg', input: 24 },
        { url: 'img/FriendsPlus/Page17/E3/52.jpg', input: 25 },
        { url: 'img/FriendsPlus/Page17/E3/53.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/54.jpg', input: 26 },
        { url: 'img/FriendsPlus/Page17/E3/55.jpg', input: 27 },
        { url: 'img/FriendsPlus/Page17/E3/56.jpg', input: 28, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/57.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page17/E3/58.jpg' },
      ],
      [
        // Column14
        { url: 'img/FriendsPlus/Page17/E3/59.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/60.jpg', input: 29 },
        { url: 'img/FriendsPlus/Page17/E3/61.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/62.jpg', input: 30 },
        { url: 'img/FriendsPlus/Page17/E3/63.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/64.jpg', input: 31, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/65.jpg' },
      ],
      [
        // Column15
        { url: 'img/FriendsPlus/Page17/E3/66.jpg' },
      ],
      [
        // Column16
        { url: 'img/FriendsPlus/Page17/E3/67.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/68.jpg', input: 32 },
        { url: 'img/FriendsPlus/Page17/E3/69.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/70.jpg', input: 33, isCorrect: true },
        { url: 'img/FriendsPlus/Page17/E3/71.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/72.jpg', input: 34 },
        { url: 'img/FriendsPlus/Page17/E3/73.jpg' },
        { url: 'img/FriendsPlus/Page17/E3/74.jpg', input: 35 },
        { url: 'img/FriendsPlus/Page17/E3/75.jpg' },
      ],
      [
        // Column17
        { url: 'img/FriendsPlus/Page17/E3/76.jpg' },
      ],
    ]
  },
  4: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P17-E4",
    audio: "img/FriendsPlus/Page17/Audio/audio-e4-p17.mp3",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page17/E4/Key/answerKey.png",
    checkUppercase: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page17/E4/1.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/2.jpg",
          audioUrl: "img/FriendsPlus/Page17/Audio/tieude-e4-p17.mp3",
        },
      ],
      [
        { url: "img/FriendsPlus/Page17/E4/3_1.jpg" },
        { url: "img/FriendsPlus/Page17/E4/3_2.jpg", input: true, answer: 'The boy has a truck.' },
        { url: "img/FriendsPlus/Page17/E4/3_3.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page17/E4/4.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/5.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/6.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/7.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/8.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/9.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/10.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/11.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/12.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/13.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/14.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/15.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/16.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/17.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/18.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page17/E4/19.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page17/E4/20.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/21.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/22.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/23.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/24.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/25.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/26.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/27.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/28.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/29.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/30.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/31.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/32.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/33.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/34.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page17/E4/35.jpg" }],
      [
        // Column7
        { url: "img/FriendsPlus/Page17/E4/36.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/37.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/38.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/39.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/40.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/41.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/42.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/43.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/44.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/45.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/dr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/46.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/47.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/tr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/48.jpg" },
        {
          url: "img/FriendsPlus/Page17/E4/49.jpg",
          // audioUrl: "img/FriendsPlus/Page17/Audio/cr.mp3",
        },
        { url: "img/FriendsPlus/Page17/E4/50.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page17/E4/51.jpg" }],
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 2",
    id: "SB3-U2-P17-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page17/E5/1.jpg" }]],
  },
};

export default json;
